export enum ClaimEstatesStatusEnum {
  created = 'CREATED',
  inAnalysis = 'IN_ANALYSIS',
  pending = 'PENDING',
  inProgress = 'IN_PROGRESS',
  finished = 'FINISHED',
  draft = 'DRAFT'
}